var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "room-stopwatch-component",
      attrs: {
        "data-grm-comp": "StopWatch",
        "data-user-relax": _vm.isRelax,
        "data-stopwatch-type": _vm.selectedStopwatchType,
        "data-pomodoro-type": _vm.selectedStopwatchSubType,
        "data-me": _vm.me,
        "data-stopwatch-state": _vm.stopwatchState,
      },
    },
    [
      _vm.selectedStopwatchType === "basic"
        ? _c(
            "div",
            {
              staticClass: "timer-item stopwatch-basic stopwatch-time",
              class: _vm.selectedStopwatchSubType,
            },
            [_vm._v(_vm._s(_vm.formatTime))]
          )
        : _vm._e(),
      !_vm.isRelax && _vm.selectedStopwatchType === "pomodoro"
        ? _c(
            "div",
            {
              staticClass: "timer-item stopwatch-pomodoro",
              class: _vm.pomodoroType,
            },
            [
              _vm.selectedStopwatchSubType === "pomodoro_rect"
                ? _c("div", { staticClass: "stopwatch-pomodoro-rect" }, [
                    _c("div", { staticClass: "pomodoro-bg square-bg" }, [
                      _c("div", { staticClass: "square-bar" }, [
                        _c("div", {
                          staticClass: "progress-bar",
                          style: _vm.pomodoroBarWidthStr,
                        }),
                      ]),
                    ]),
                    _c("div", { staticClass: "pomodoro-time-tx" }, [
                      _c("div", { staticClass: "count-time" }, [
                        _vm._v(_vm._s(_vm.pomodoroTimeStr) + " 22"),
                      ]),
                      _c(
                        "div",
                        { staticClass: "cumulative-time stopwatch-time" },
                        [_vm._v(_vm._s(_vm.formatTime) + " 33")]
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm.selectedStopwatchSubType === "pomodoro_circle"
                ? _c("div", { staticClass: "stopwatch-pomodoro-circle" }, [
                    _c("div", { staticClass: "pomodoro-bg circle-bg" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            version: "1.1",
                          },
                        },
                        [
                          _c("circle", {
                            style: _vm.pomodoroCircleWidthStr,
                            attrs: {
                              id: "circle",
                              cx: "0",
                              cy: "0",
                              r: "42",
                              "stroke-dasharray": "430",
                              "stroke-width": "4px",
                              stroke: "#51a9fe",
                              fill: "transparent",
                              transform: "translate(44,44) rotate(-90)",
                            },
                          }),
                        ]
                      ),
                    ]),
                    _c("div", { staticClass: "pomodoro-time-tx" }, [
                      _c("div", { staticClass: "count-time" }, [
                        _vm._v(_vm._s(_vm.pomodoroTimeStr)),
                      ]),
                      _c(
                        "div",
                        { staticClass: "cumulative-time stopwatch-time" },
                        [_vm._v(_vm._s(_vm.formatTime))]
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm.selectedStopwatchSubType === "pomodoro_mobile"
                ? _c("div", { staticClass: "stopwatch-pomodoro-mobile" }, [
                    _c("div", { staticClass: "pomodoro-bg square-bg" }, [
                      _c("div", { staticClass: "square-bar" }, [
                        _c("div", {
                          staticClass: "progress-bar",
                          style: _vm.pomodoroBarWidthStr,
                        }),
                      ]),
                    ]),
                    _c("div", { staticClass: "pomodoro-time-tx" }, [
                      _c("div", { staticClass: "count-time" }, [
                        _vm._v(_vm._s(_vm.pomodoroTimeStr)),
                      ]),
                      _c(
                        "div",
                        { staticClass: "cumulative-time stopwatch-time" },
                        [_vm._v(_vm._s(_vm.formatTime))]
                      ),
                    ]),
                  ])
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm.selectedStopwatchType === "cash-item-01"
        ? _c(
            "div",
            {
              staticClass: "timer-item stopwatch-cash-set-01",
              attrs: { "data-timer-type": _vm.selectedStopwatchSubType },
            },
            [
              _c("div", { staticClass: "room-stopwatch-shape" }, [
                _c(
                  "div",
                  {
                    staticClass: "room-stopwatch-shape-tx stopwatch-shape-time",
                  },
                  [_vm._v(_vm._s(_vm.formatTime))]
                ),
              ]),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }